/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import PropTypes from 'prop-types'

const Icon = ({ width, height, color, ...restProps }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.2232 7.76622C16.0278 7.57108 15.7112 7.57128 15.5161 7.76666L11.9971 11.2901L8.47343 7.76644C8.27816 7.57118 7.96158 7.57118 7.76632 7.76644C7.57106 7.9617 7.57106 8.27829 7.76632 8.47355L11.2904 11.9976L7.77095 15.5215C7.57581 15.7169 7.57601 16.0335 7.7714 16.2286C7.96678 16.4238 8.28336 16.4236 8.4785 16.2282L11.9975 12.7048L15.5163 16.2236C15.7116 16.4188 16.0282 16.4188 16.2234 16.2236C16.4187 16.0283 16.4187 15.7117 16.2234 15.5165L12.7042 11.9972L16.2236 8.47333C16.4188 8.27794 16.4186 7.96136 16.2232 7.76622Z"
      fill={color}
    />
  </svg>
)

Icon.defaultProps = {
  width: '24',
  height: '24',
  color: '#BE1313',
}
Icon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
}

export default Icon
